"use client";

import { ApiCatalog } from "@/api/catalog";
import { useQuery } from "@tanstack/react-query";

export const useCatalogData = () => {
  const { data: catalog, isLoading } = useQuery({
    queryKey: ["catalog"],
    queryFn: () => ApiCatalog.getCatalog(),
  });

  return { catalog, isLoading };
};
